<template>
  <article class="locker-row">
    <ProductImageProofContainer :product="product" />

    <div class="product-info">
      <img
        v-if="product && product.brand"
        :src="
          require(`@/assets/branding/${product.brand
            .replace(/\s+/g, '-')
            .toLowerCase()}.png`)
        "
        alt="branding icon"
      />
      <p class="slate-bold product-name">
        {{ product.name }}
        <span class="slate-light">{{ product.alias }}</span>
      </p>
      <div class="product-prices-info">
        <div class="product-price-info-row">
          <span class="slate-light">Quote Price</span>
          <span>{{
            showPrices ? `$${estimatedPrice}` : "No Pricing Shown"
          }}</span>
        </div>
        <div class="product-price-info-row">
          <span class="slate-light">Your Price</span>
          <span>${{ estimatedMSRP }}</span>
        </div>
        <!-- <div class="product-price-info-row">
          <span class="slate-light">Lead Time</span>
          <span>{{ productLeadTime }} Bussiness Days</span>
        </div> -->
      </div>
    </div>

    <div class="quanty-and-link">
      <div class="quantity">
        <span>Quantity</span>
        <p>{{ productQuantity }} Pieces</p>
      </div>
      <!-- Disabled open in builder -->
      <button v-if="!builderURL" disabled class="slate btn disabled">
        Open in Builder
      </button>
      <!-- Enabled Open in Builder -->
      <a
        v-if="builderURL"
        class="slate btn btn-black"
        target="_blank"
        rel="noreferrer "
        :href="builderURL"
        >Open in Builder</a
      >
      <!-- Roster/Sizes Check -->
      <div class="roster-or-sizes-check">
        <span>{{
          showRosterOptions
            ? noRosterProvided
              ? "Missing Roster"
              : "Roster Provided"
            : noSizesProvided
            ? "Missing Sizes"
            : "Sizes Provided"
        }}</span>

        <img
          :src="
            noRosterProvided && noSizesProvided
              ? require('@/assets/icons/ui/cross-circle-outline.png')
              : require('@/assets/icons/ui/checkmark-circle-outline.png')
          "
          alt=""
        />
      </div>
    </div>
  </article>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "MyQuoteDetailsItem",
  props: {
    product: {
      type: Object,
      required: true,
    },
    showPrices: {
      type: Boolean,
      required: true,
    },
  },

  computed: {
    ...mapGetters("lockerModule", ["getProductQuantityById"]),

    builderURL() {
      const builderCode = this.product.configId;
      return builderCode
        ? `${process.env.VUE_APP_BUILDER_SITE}/configure/?ConfigId=${builderCode}`
        : null;
    },

    estimatedPrice() {
      if (this.productQuantity) {
        const price =
          (Number(this.product.productPrice) +
            Number(this.product.decorationsPrice)) *
          this.productQuantity;
        return Number(price).toFixed(2);
      }
      return 0;
    },

    estimatedMSRP() {
      if (this.productQuantity) {
        const msrp =
          (Number(this.product.productMsrp) +
            Number(this.product.decorationsMsrp)) *
          this.productQuantity;
        return msrp.toFixed(2);
      }
      return 0;
    },

    lockerProductId() {
      return this.product.lockerProductId;
    },
    productLeadTime() {
      return this.product?.production_time;
    },

    productQuantity() {
      return this.product.quantity;
    },
    hasNumber() {
      return !!this.numberDecoration;
    },

    hasPlayerName() {
      return !!this.playerNameDecoration;
    },

    noRosterProvided() {
      return !this.product.roster;
    },

    noSizesProvided() {
      return !this.product.sizes_selection;
    },

    numberDecoration() {
      return this.productDecorations?.filter(
        (decoration) =>
          decoration?.configuration?.["Content Type"] === "Player Number"
      )?.[0];
    },

    playerNameDecoration() {
      return this.productDecorations?.filter(
        (decoration) =>
          decoration?.configuration?.["Content Type"] === "Player Name"
      )?.[0];
    },

    productDecorations() {
      return this.product?.threekit_decorations;
    },

    showRosterOptions() {
      return this.hasPlayerName || this.hasNumber;
    },

    showSizesOptions() {
      return !this.showRosterOptions;
    },
  },
};
</script>

<style lang="scss" scoped>
.locker-row {
  border-bottom: 1px solid black;
  display: flex;
  min-height: 180px;
  margin-bottom: 1rem;
  padding: 1.25rem;
  ::v-deep .uniform-vectors-container {
    align-items: center;
    width: 50%;
    margin-right: 1rem;
    img {
      margin-bottom: 0;
    }
  }

  .product-info {
    display: flex;
    flex-direction: column;

    width: 25%;
    height: 100%;
    img {
      display: block;
      height: 1.5rem;
      max-width: 100%;
      margin-right: auto;
      margin-bottom: 0.5rem;
    }
    .product-name {
      margin-bottom: 1rem;
    }
    .product-prices-info {
      display: flex;
      flex-direction: column;
      margin-top: auto;
      .product-price-info-row {
        display: flex;
        /* align-items: center; */
        margin-bottom: 0.1rem;
        span {
          margin-right: 0.5rem;
          &:first-child {
            width: 40%;
          }
        }
      }
    }
  }

  .quanty-and-link {
    width: 15%;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: auto;
    margin-left: auto;
    .quantity {
      display: flex;
      margin-bottom: 0.75rem;
      span {
        margin-right: 0.5rem;
        color: $grey-dark;
      }
    }
    button {
      background: $dark;
      color: white;
      text-transform: uppercase;
      margin-bottom: 0.75rem;
    }

    .roster-or-sizes-check {
      display: flex;
      align-items: center;
      span {
        margin-right: 0.5rem;
      }
      img {
        width: 1.25rem;
        height: auto;
      }
    }
  }
}
</style>
